export const API_VERSION = 'v1' as const;
export const V2_API = 'v2' as const;

export const NEXT_WORK_ORDER_NUMBER = 'next-work-order-number' as const;
